
import { useAuthContext } from '../contexts/AuthContext';

export const useAuth = () => {
  const { user, profile, loading, isAuthenticated, isSuperAdmin, signOut, refreshProfile, role } = useAuthContext();

  return {
    user,
    profile,
    role,
    loading,
    isAuthenticated,
    isSuperAdmin,
    signOut,
    refreshProfile
  };
};
